<template>
    <v-dialog v-model="dialog" max-width="750" scrollable :fullscreen="$vuetify.breakpoint.smAndDown">
        <template #activator="{ on }">
            <v-btn @click="showNormalValue" v-on="on" text x-small class="mr-2">
                <v-icon left>mdi-test-tube</v-icon>
                Nilai normal
            </v-btn>
        </template>

        <v-card>
            <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title class="title">Referensi Nilai Lab Normal</v-list-item-title>
                    <v-list-item-subtitle>http://rc.gnomio.com</v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                    <v-btn @click="dialog = false" icon>
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-list-item-action>
            </v-list-item>

            <v-card-text>
                <h4 class="title">HEMATOLOGI</h4>

                <v-simple-table>
                    <tbody>
                        <tr>
                            <td>
                                Erythrocyte count
                            </td>
                            <td>
                                4.2-5.9 ×106/μL (4.2-5.9 x 1012 cells/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Erythrocyte sedimentation rate
                            </td>
                            <td>
                                Male: 0-15 mm/h Female: 0-20 mm/h
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Erythropoietin
                            </td>
                            <td>
                                less than 30 mU/mL (30 U/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Haptoglobin serum
                            </td>
                            <td>
                                50-150 mg/dL (500-1500 mg/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Hematocrit
                            </td>
                            <td>
                                Male: 41%-51% Female: 36%-47%
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Hemoglobin,
                            </td>
                            <td>
                                Male: 14-17 g/dL (140-170 g/L) Female: 12-16 g/dL (120-160 g/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Mean corpuscular hemoglobin
                            </td>
                            <td>
                                28-32 pg
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Mean corpuscular hemoglobin concentration 32-36 g/dL (320-360 g/L)
                            </td>
                            <td>
                                32-36 g/dL (320-360 g/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Mean corpuscular volume
                            </td>
                            <td>
                                80-100 fL
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Reticulocyte count
                            </td>
                            <td>
                                0.5%-1.5% of erythrocytes; absolute: 23,000-90,000 cells/μL (23-90 ×109/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Leukocyte count
                            </td>
                            <td>
                                4000-10,000/μL (4.0-10 ×109/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Platelet count
                            </td>
                            <td>
                                150,000-350,000/μL (150-350 ×109/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Bleeding time
                            </td>
                            <td>
                                Less than 10 min
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Activated partial thromboplastin time
                            </td>
                            <td>
                                25-35 s
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Prothrombin time
                            </td>
                            <td>
                                11-13 s
                            </td>
                        </tr>
                        <tr>
                            <td>
                                D-Dimer
                            </td>
                            <td>
                                less than 0.5 μg/mL (500 mg/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Ferritin
                            </td>
                            <td>
                                15-200 ng/mL (15-200 mg/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Iron serum
                            </td>
                            <td>
                                60-160 μg/dL (11-29 μmol/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                TIBC
                            </td>
                            <td>
                                250-460 μg/dL (45-82 μmol/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Transferrin saturation
                            </td>
                            <td>
                                20%-50%
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>

                <h4 class="title mt-6">BLOOD, PLASMA, AND SERUM CHEMISTRY STUDIES</h4>

                <v-simple-table>
                    <tbody>
                        <tr>
                            <td>
                                Albumin serum
                            </td>
                            <td>
                                3.5-5.5 g/dL (35-55 g/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                α-Fetoprotein
                            </td>
                            <td>
                                0-20 ng/mL (0-20 μg/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Aminotransferase, alanine (ALT) / SGPT
                            </td>
                            <td>
                                0-35 U/L
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Aminotransferase, aspartate (AST) / SGOT
                            </td>
                            <td>
                                0-35 U/L
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Ammonia plasma
                            </td>
                            <td>
                                40-80 μg/dL (23-47 μmol/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Amylase, serum
                            </td>
                            <td>
                                0-130 U/L
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Antinuclear antibody
                            </td>
                            <td>
                                positive: titer > 1:160
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Bicarbonate serum
                            </td>
                            <td>
                                23-28 meq/L (23-28 mmol/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Bilirubin serum
                            </td>
                            <td>
                                Total: 0.3-1.2 mg/dL (5.1-20.5 μmol/L) Direct: 0-0.3 mg/dL (0-5.1 μmol/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Blood urea nitrogen
                            </td>
                            <td>
                                8-20 mg/dL (2.9-7.1 mmol/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Cholesterol, plasma Total
                            </td>
                            <td>
                                150-199 mg/dL (3.88-5.15 mmol/L), desirable
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Low-density lipoprotein (LDL)
                            </td>
                            <td>
                                Less than or equal to 130mg/dL (3.36 mmol/L), desirable
                            </td>
                        </tr>
                        <tr>
                            <td>
                                High-density lipoprotein (HDL)
                            </td>
                            <td>
                                Greater than or equal to40 mg/dL (1.04 mmol/L), desirable
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Complement serum C3
                            </td>
                            <td>
                                55-120 mg/dL (550-1200 mg/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Total (CH50)
                            </td>
                            <td>
                                37-55 U/mL (37-55 kU/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Creatine kinase, serum
                            </td>
                            <td>
                                30-170 U/L
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Creatinine serum
                            </td>
                            <td>
                                0.7-1.3 mg/dL (61.9-115 μmol/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Electrolytes, serum
                            </td>
                            <td>
                                Sodium 136-145 meq/L (136-145 mmol/L) Potassium 3.5-5.0 meq/L (3.5-5.0 mmol/L)  Chloride 98-106 meq/L (98-106 mmol/L)  Magnesium 1.5-2.4 mg/dL (0.62-0.99 mmol/L)  Phosphorus 3-4.5 mg/dL (0.97-1.45 mmol/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Fibrinogen, plasma
                            </td>
                            <td>
                                150-350 mg/dL (1.5-3.5 g/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Glucose, plasma
                            </td>
                            <td>
                                Fasting, 70-100 mg/dL (3.9-5.6 mmol/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                γ-Glutamyltransferase, serum
                            </td>
                            <td>
                                0-30 U/L
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Homocysteine
                            </td>
                            <td>
                                Male: 4-16 μmol/L female: 3-14 μmol/L
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Immunoglobulins
                            </td>
                            <td>
                                IgG: 640-1430 mg/dL (6.4-14.3 g/L) IgA: 70-300 mg/dL (0.7-3.0 g/L)  IgM: 20-140 mg/dL (0.2-1.4 g/L)  IgD: Less than 8 mg/dL (80 mg/L)  IgE: 0.01-0.04 mg/dL (0.1-0.4 mg/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Lactate dehydrogenase
                            </td>
                            <td>
                                60-100 U/L
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Lactic acid, venous blood
                            </td>
                            <td>
                                6-16 mg/dL (0.67-1.8 mmol/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Lipase, serum
                            </td>
                            <td>
                                Less than 95 U/L
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Protein, serum
                            </td>
                            <td>
                                Total: 6.0-7.8 g/dL (60-78 g/L) Albumin: 3.5-5.5 g/dL (35-55 g/L)  Globulins: 2.5-3.5 g/dL (25-35 g/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Prostate-specific antigen, serum
                            </td>
                            <td>
                                optimal less than 4 ng/mL
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Rheumatoid factor
                            </td>
                            <td>
                                less than 40 U/mL (less than 40 kU/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Transferrin saturation
                            </td>
                            <td>
                                20%-50%
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Triglycerides
                            </td>
                            <td>
                                Less than 250 mg/dL (2.82 mmol/L), desirable
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Troponins, serum
                            </td>
                            <td>
                                Troponin I: 0-0.5 ng/mL (0-0.5 μg/L) Troponin T:0-0.10 ng/mL (0-0.10 μg/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Uric acid
                            </td>
                            <td>
                                2.5-8 mg/dL (0.15-0.47 mmol/L)
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>

                <h4 class="title mt-6">ENDOCRINE</h4>

                <v-simple-table>
                    <tbody>
                        <tr>
                            <td>
                                Adrenocorticotropin (ACTH)
                            </td>
                            <td>
                                9-52 pg/mL (2-11 pmol/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Aldosterone, serum
                            </td>
                            <td>
                                Supine - 2-5 ng/dL (55-138 pmol/L) Standing - 7-20 ng/dL (194-554 pmol/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Aldosterone, urine
                            </td>
                            <td>
                                5-19 μg/24 h (13.9-52.6 nmol/24 h)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Catecholamines
                            </td>
                            <td>
                                Epinephrine plasma (supine): less than 75 ng/L (410 pmol/L) Norepinephrine, plasma (supine): 50-440 ng/L (296-2600 pmol/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Catecholamines, 24-hour, urine
                            </td>
                            <td>
                                Less than 100 μg/m2per 24 h (591 nmol/m2 per 24 h)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Cortisol free, urine
                            </td>
                            <td>
                                Less than 90 μg/24 h (248 nmol/24 h)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Dehydroepiandrosterone sulfate (DHEA), plasma
                            </td>
                            <td>
                                Male: 1.3-5.5 mg/mL (3.5-14.9 μmol/L) Female: 0.6-3.3 mg/mL (1.6-8.9 μmol/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Estradiol, serum
                            </td>
                            <td>
                                Male: 10-30 pg/mL (37-110 pmol/L); Female: day 1-10, 50-100 pmol/L; day 11-20, 50-200 pmol/L;  day 21-30, 70-150 pmol/L
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Follicle-stimulating hormone, serum
                            </td>
                            <td>
                                Male (adult): 5-15 mU/mL (5-15 U/L) Female: follicular or luteal phase, 5-20 mU/mL (5-20 U/L);  midcycle peak, 30-50 mU/mL (30-50 U/L); postmenopausal, greater than 35 mU/mL (35 U/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Growth hormone, plasma
                            </td>
                            <td>
                                After oral glucose, less than 2 ng/mL (2 μg/L); response to provocative stimuli: greater than 7 ng/mL (7 μg/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Luteinizing hormone, serum
                            </td>
                            <td>
                                Male: 3-15 mU/mL (3-15 U/L) Female: follicular or luteal phase, 5-22 mU/mL (5-22 U/L);  midcycle peak, 30-250 mU/mL (30-250 U/L);  postmenopausal, greater than 30 mU/mL (30 U/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Parathyroid hormone, serum
                            </td>
                            <td>
                                10-65 pg/mL (10-65 ng/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Prolactin, serum
                            </td>
                            <td>
                                Male: less than 15 ng/mL (15 mg/L); Female: less than 20 ng/mL (20 mg/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Testosterone, serum
                            </td>
                            <td>
                                Male (adult): 300-1200 ng/dL (10-42 nmol/L) Female: 20-75 ng/dL (0.7-2.6 nmol/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Thyroid function tests (normal ranges vary)
                            </td>
                            <td>
                                Thyroid iodine (131I) uptake: 10% to 30% of administered dose at 24 h
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Thyroid-stimulating hormone (TSH)
                            </td>
                            <td>
                                0.5-5.0 μU/mL (0.5-5.0 mU/mL)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Thyroxine (T4), serum
                            </td>
                            <td>
                                Total - 5-12 μg/dL (64-155 nmol/L) Free - 0.9-2.4 ng/dL (12-31 pmol/L)  Free T4 index: 4-11
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Triiodothyronine, resin (T3)
                            </td>
                            <td>
                                25%-35%
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Triiodothyronine, serum (T3)
                            </td>
                            <td>
                                70-195 ng/dL (1.1-3.0 nmol/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Vanillylmandelic acid, urine
                            </td>
                            <td>
                                Less than 8 mg/24 h (40.4 μmol/24 h)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Vitamin D 1,25-dihydroxy, serum
                            </td>
                            <td>
                                25-65 pg/mL (60-156 pmol/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                25-hydroxy, serum
                            </td>
                            <td>
                                15-80 ng/mL (37-200 nmol/L)
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>

                <h4 class="title mt-6">ARTERIAL BLOOD GAS ANALYSIS</h4>
                <v-simple-table>
                    <tbody>
                        <tr>
                            <td>
                                pH
                            </td>
                            <td>
                                7.38-7.44
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Pco2
                            </td>
                            <td>
                                35-45 mm Hg
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Po2
                            </td>
                            <td>
                                80-100 mm Hg
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Oxygen saturation
                            </td>
                            <td>
                                95% or greater
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Bicarbonate
                            </td>
                            <td>
                                23-28 meq/L (23-28 mmol/L)
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>

                <h4 class="title mt-6">URINE</h4>

                <v-simple-table>
                    <tbody>
                        <tr>
                            <td>
                                Albumin–creatinine ratio
                            </td>
                            <td>
                                &lt; 30 mg/g
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Calcium
                            </td>
                            <td>
                                100-300 mg/24 h (2.5-7.5 mmol/24 h) on unrestricted diet
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Creatinine
                            </td>
                            <td>
                                15-25 mg/kg per 24 h (133-221 mmol/kg per 24 h)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Creatinine clearance
                            </td>
                            <td>
                                90-140 mL/min (0.09-0.14 L/min)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                5-Hydroxyindoleacetic acid (5-HIAA)
                            </td>
                            <td>
                                2-9 mg/24 h (10.4-46.8 μmol/24 h)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Protein–creatinine ratio
                            </td>
                            <td>
                                &lt; 0.2 mg/mg
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Sodium
                            </td>
                            <td>
                                100-260 meq/24 h (100-260 mmol/24 h) (varies with intake)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Uric acid
                            </td>
                            <td>
                                250-750 mg/24 h (1.48-4.43 mmol/24 h) (varies with diet)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Gastrin, serum
                            </td>
                            <td>
                                0-180 pg/mL (0-180 ng/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Stool fat
                            </td>
                            <td>
                                Less than 5 g/d on a 100-g fat diet
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Stool weight
                            </td>
                            <td>
                                Less than 200 g/d
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>

                <h4 class="title mt-6">PULMONARY</h4>

                <v-simple-table>
                    <tbody>
                        <tr>
                            <td>
                                Forced expiratory volume in 1 second (FEV1)
                            </td>
                            <td>
                                > 80% predicted
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Forced vital capacity (FVC)
                            </td>
                            <td>
                                > 80% predicted
                            </td>
                        </tr>
                        <tr>
                            <td>
                                FEV1/FVC
                            </td>
                            <td>
                                Greater than 75% (0.75)
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>

                <h4 class="title mt-6">CEREBROSPINAL FLUID</h4>
                <v-simple-table>
                    <tbody>
                        <tr>
                            <td>
                                Cell count
                            </td>
                            <td>
                                0-5 cells/μL (0-5 ×106cells/L)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Glucose
                            </td>
                            <td>
                                40-80 mg/dL (2.5-4.4 mmol/L); less than 40% of simultaneous plasma concentration is abnormal
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Pressure (opening)
                            </td>
                            <td>
                                70-200 cm H2O
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Protein
                            </td>
                            <td>
                                15-60 mg/dL (150-600 mg/L)
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>

                <h4 class="title mt-6">HEMODYNAMIC MEASUREMENTS</h4>

                <v-simple-table>
                    <tbody>
                        <tr>
                            <td>
                                Cardiac index
                            </td>
                            <td>
                                2.5–4.2 L/min/m2
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Left ventricular ejection fraction
                            </td>
                            <td>
                                45%–70%
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Pulmonary artery pressure
                            </td>
                            <td>
                                Systolic: 20–25 mm Hg Diastolic: 5–10 mm Hg  Mean: 9–16 mm Hg
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Pulmonary capillary wedge
                            </td>
                            <td>
                                6–12 mm Hg
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Right atrium
                            </td>
                            <td>
                                mean 0–5 mm Hg
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Right ventricle
                            </td>
                            <td>
                                Systolic: 20–25 mm Hg Diastolic: 0–5 mm Hg
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return {
            dialog: false
        }
    },

    methods: {
        showNormalValue() {
            this.$tracking.event.tryout.normalValue(
                `${this.$store.get('tryout/title')} ${this.$store.get('enrollment/selected@title')}`,
                this.$store.get('tryout/activeQuestionIdx') + 1
            )
        }
    }
}
</script>
